export type MultiplayerBasePayloadType<T = Record<string, never>> = {
  designId?: string;
  projectId?: string;
  teamId?: string;
  userId?: string;
  usersLocation?: UsersLocation[];
} & T;

export type UsersLocation = {
  userId: string;
  designId: string | undefined;
  projectId: string | undefined;
  teamId: string | undefined;
  latestUpdate: number;
};

export interface CursorPointerWebsocketMessageResponse {
  designId: string;
  userId: string;
  x: number;
  y: number;
  side: string;
}

export type CursorEntry = {
  userId: string;
  x: number;
  y: number;
  color: string;
  side: string;
};

export interface CollaboratorType {
  imageUrl?: string;
  userId: string;
  initials: string;
  designId?: string;
  projectId?: string;
  teamId?: string;
}

export enum EventType {
  CONNECT = "Connect",
  DISCONNECT = "Disconnect",
  CURSOR_POSITION = "CursorPosition",
  JOIN_DESIGN = "JoinedDesign",
  LEAVE_DESIGN = "LeftDesign",
  JOIN_PROJECT = "JoinedProject",
  LEAVE_PROJECT = "LeftProject",
  JOIN_TEAM = "JoinedTeam",
  LEAVE_TEAM = "LeftTeam",
  WHO_IS_IN_THE_TEAM = "WhoIsInTheTeam",
  WHO_IS_IN_THE_PROJECT = "WhoIsInTheProject",
  WHO_IS_IN_THE_DESIGN = "WhoIsInTheDesign",
  UPDATE_COLLABORATORS_LOCATION = "UpdateCollaboratorsLocation",
}

export enum BackendEventType {
  // Design events
  DESIGN_CREATED = "DESIGN_CREATED",
  DESIGN_RENAMED = "DESIGN_RENAMED",
  DESIGN_MOVED = "DESIGN_MOVED",
  DESIGN_DELETED = "DESIGN_DELETED",
  DESIGN_FAVORITED = "DESIGN_FAVORITED",
  DESIGN_UPDATE = "DESIGN_UPDATE",
  DESIGN_LOCKED = "DESIGN_LOCKED",
  DESIGN_UNLOCKED = "DESIGN_UNLOCKED",

  // Project events
  PROJECT_CREATED = "PROJECT_CREATED",
  PROJECT_DUPLICATED = "PROJECT_DUPLICATED",
  PROJECT_CONVERTED_TO_TEAM = "PROJECT_CONVERTED_TO_TEAM",
  PROJECT_RENAMED = "PROJECT_RENAMED",
  PROJECT_DELETED = "PROJECT_DELETED",
  PROJECT_MOVED_TO_TEAM = "PROJECT_MOVED_TO_TEAM",
  PROJECT_UPDATED = "PROJECT_UPDATED",

  // Team events
  TEAM_MEMBER_ADDED = "TEAM_MEMBER_ADDED",
  TEAM_MEMBER_LEFT = "TEAM_MEMBER_LEFT",
  TEAM_CREATED = "TEAM_CREATED", // Currently unused because no one will be notified
  TEAM_RENAMED = "TEAM_RENAMED",
  TEAM_DELETED = "TEAM_DELETED",

  //user events
  USER_ADDED_TO_TEAM = "USER_ADDED_TO_TEAM",
  USER_REMOVED_FROM_TEAM = "USER_REMOVED_FROM_TEAM",
}

export type MultiplayerEventType = EventType | BackendEventType;
